<dx-popup title="Invoices" [width]="1000" [height]="800" [(visible)]="visible" [hideOnOutsideClick]="false" (onHiding)="onHiding($event)">
    <dx-data-grid
        #customerInvoicesGrid
        keyExpr="id"
        class="d-flex flex-fill flex-column"
        [dataSource]="invoices"
        [height] = "'400px'"
        [showBorders]="true"
        style="min-height: 650px; min-width: 750px"
        (onToolbarPreparing)="onToolbarPreparing($event)"
    >
        <dxi-data-grid-column dataField="id" caption="Id" width="75"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="invoiceNumber" caption="Invoice #" width="75"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="status.name" caption="Status" width="100"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="total" [format]="{ type: 'currency', precision: 2 }" width="100"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="invoiceDate" caption="Date" width="100"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="sent" format="shortDate" caption="Sent" width="150"></dxi-data-grid-column>
        <dxi-data-grid-column dataField="displayServiceAddress" caption="Service Address"></dxi-data-grid-column>
        <dxi-data-grid-column></dxi-data-grid-column>

        <div *dxTemplate="let data of 'toolbarButtons'"></div>
        <div *dxTemplate="let data of 'toolbarText'">
            <span class="me-3">
                <strong>{{ customerInvoicesGrid.instance.totalCount() + ' items' }}</strong>
            </span>
        </div>
        <dxo-data-grid-selection [mode]="'single'"></dxo-data-grid-selection>
    </dx-data-grid>
</dx-popup>
